// Property units data extracted from brochure images
export const propertyUnits = [
  {
    id: 'culiano',
    name: 'Culiano',
    type: 'Maisonette',
    size: '400SQM',
    features: [
      '4 Bedroom + BQ',
      'Living Room',
      'Modern Kitchen',
      'Study',
      'Dining Room',
      'Fibre to the Home',
      'Car Park',
      'Pantry'
    ],
    image: 'aiben1.jpeg',
    badge: 'Premium'
  },
  {
    id: 'anfield',
    name: 'Anfield',
    type: 'Maisonette',
    size: '500SQM',
    features: [
      '5 Bedroom + BQ',
      'Living Room',
      'Modern Kitchen',
      'Study',
      'Dining Room',
      'Fibre to the Home',
      'Car Park',
      'Pantry'
    ],
    image: 'aiben2.jpeg',
    badge: 'Luxury'
  },
  {
    id: 'sansiro',
    name: 'Sansiro',
    type: 'Maisonette',
    size: '500SQM',
    features: [
      '5 Bedroom + BQ',
      'Living Room',
      'Modern Kitchen',
      'Study',
      'Dining Room',
      'Fibre to the Home',
      'Car Park',
      'Pantry'
    ],
    image: 'aiben3.jpeg',
    badge: 'Luxury'
  },
  {
    id: 'santiago-bay',
    name: 'Santiago Bay',
    type: 'Villa',
    size: '750SQM',
    features: [
      '5 Bedroom + BQ',
      'Living Room',
      'Modern Kitchen',
      'Study',
      'Dining Room',
      'Fibre to the Home',
      'Car Park',
      'Pantry'
    ],
    image: 'aiben4.jpeg',
    badge: 'Ultra Luxury'
  },
  {
    id: 'faruja',
    name: 'Faruja',
    type: 'Block of Flats',
    size: '1000SQM',
    features: [
      '3 Bedroom + BQ',
      'Living Room',
      'Modern Kitchen',
      'Study',
      'Dining Room',
      'Fibre to the Home',
      'Car Park',
      'Pantry'
    ],
    image: 'aiben5.jpeg',
    badge: 'Investment'
  },
  {
    id: 'ferragamo',
    name: 'Ferragamo',
    type: 'Terrace Duplex',
    size: '250SQM',
    features: [
      '4 Bedroom + BQ',
      'Living Room',
      'Modern Kitchen',
      'Study',
      'Dining Room',
      'Fibre to the Home',
      'Car Park',
      'Pantry'
    ],
    image: 'aiben1.jpeg',
    badge: 'Smart Living'
  }
];

export default propertyUnits;
